module.exports = __webpack_public_path__ + "img/KY.57ed8eaa.svg";